import { makeAutoObservable } from 'mobx';
import { FilmAnalysisAndRepairReportService } from './service';

class FilmAnaysisAndRepairReportStore {
  Loading: boolean = false;
  constructor() {
    makeAutoObservable(this);
  }

  getTitleName = async () => {
    try {
      const Reponse = await FilmAnalysisAndRepairReportService.getTitleName();
      return Reponse.data;
    } catch (error) {
      console.log('FilmAnaysisAndRepairReport error throwing ...');
    }
  };
  getTitleNameCount = async (title: string) => {
    try {
      const Reponse =
        await FilmAnalysisAndRepairReportService.getTitleNameCount(title);
      return Reponse.data;
    } catch (error) {
      console.log('FilmAnaysisAndRepairReport error throwing ...');
    }
  };
  finalAnalysisRepairReports = async (title: string) => {
    try {
      const Reponse =
        await FilmAnalysisAndRepairReportService.finalAnalysisRepairReports(
          title,
        );
      this.Loading = false;
      return Reponse.data;
    } catch (error) {
      console.log('FilmAnaysisAndRepairReport error throwing ...');
    }
  };
  setLoading = async (condition: boolean) => {
    this.Loading = condition;
  };
}
export default FilmAnaysisAndRepairReportStore;
